export default __webpack_public_path__ + "static/backgroundMedia-280bbee22156d97282c4becba617253f.jpg";